import { render } from "./FiltersBlock.vue?vue&type=template&id=5faca20a&scoped=true"
import script from "./FiltersBlock.vue?vue&type=script&lang=js"
export * from "./FiltersBlock.vue?vue&type=script&lang=js"

import "./FiltersBlock.vue?vue&type=style&index=0&id=5faca20a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5faca20a"]])

export default __exports__